<template>
    <TheNav></TheNav>
    <div class="p-8" >
        <h3> 图标01： </h3>
        <!-- <IconSvg class="show-them-all" isShowAll :style="{margin: 0}" /> -->
    </div>
    <!--  -->
    <!--  -->
    <div class="p-8" >
        <h3> 图标01.2： </h3>
        <div class="all-coins" >
            <!-- <IconCoinSvg  name="btc" :style="{margin: 0}" /> -->
        </div>
    </div>
    <!--  -->
    <!--  -->
    <!--  -->
    <div class="p-8" >
        <h3> 图标02-调用示例：</h3>
        <div class="svg-box">
            <IconSvgUse use="icon-arrow-up" width="30" height="30"/> 
            <IconSvgUse use="icon-arrow-up" width="30" height="30" fill="white"/> 
            <IconSvgUse use="icon-arrow-down" width="30" height="30" fill="pink"/>
            <IconSvgUse use="icon-horse-racing" width="50" height="50" fill="yellow"/>
            <IconSvgUse use="icon-gaelic-sports" width="50" height="50" fill="aqua"/>
        </div>
    </div>
    <br/>
    <br/>
    <div class="p-8" >
        <h3> 图标02-平铺用于浏览： （一些图标显示为空，需要指定样式，例如 stroke: red;）</h3>
        <div class="svg-box">
            <IconSvgUse v-for="(sIconName, idx) of aIconNames"
                :key="idx"
                width="35"
                height="35"
                size="35px"
                :use="sIconName"
                :use-value="sIconName"
            >uuuuuuu
            </IconSvgUse>
        </div>
        <br/>
        <br/>
        <div class="svg-box">
            <IconSvgUse v-for="(sIconName, idx) of aHiloIcons"
                :key="idx"
                width="35"
                height="35"
                fileName="hilo"
                :use="sIconName"
                :use-value="sIconName"
            >
            </IconSvgUse>
        </div>
        <!-- <br />
        <br />
        <div class="svg-box">
            <IconSvgUse v-for="(sIconName, idx) of selectIcons"
                :key="idx"
                width="17"
                height="17"
                fileName="select"
                :use="sIconName"
                :use-value="sIconName"
            >
            </IconSvgUse>
        </div> -->
        <br />
        <br />
        <div class="svg-box">
            <IconSvgUse v-for="(sIconName, idx) of homeSvg"
                :key="idx"
                width="24"
                height="24"
                fileName="home"
                :use="sIconName"
                :use-value="sIconName"
            >
            </IconSvgUse>
        </div>
    </div>
</template>

<script>
import TheNav from './nav.vue';
import {aIconNames, aHiloIcons, homeSvg} from '@/components/Icon/SvgUse.vue';

export default {
    components: {
        TheNav,
    },
    data(){
        return {
            aIconNames,
            aHiloIcons,
            // selectIcons,
            homeSvg
        };
    },
    methods:{

    },
};
</script>

<style scoped lang="scss">

.svg-box,
.show-them-all{
    max-width: 900px;
}

.svg-box{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    fill: white;
    color: white;
    // stroke: white;
}
.all-coins{
    &>*{
        display: inline-block;
        width: 30px;
    }
}
</style>

